module.exports = __webpack_public_path__ + "static/media/promjenaLozinke.6aeb0d20.svg";